var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckboxChecked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "0BDF7B9D-F747-486B-ACFA-7721C13F704C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uC13C\\uD2B8\\uB9AD\\uC2A4_\\uC774\\uAD00",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CTI_\\uC13C\\uD2B8\\uB9AD\\uC2A4_\\uC0C1\\uB2F4_element",
    transform: "translate(-1061.000000, -1502.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "checkbox_call_on",
    transform: "translate(1061.000000, 1502.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "currentColor",
    x: 0,
    y: 0,
    width: 14,
    height: 14,
    rx: 3
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "3.73462238 7 6.48032784 9.91900267 10.5915385 5.33115498"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxChecked);
export default __webpack_public_path__ + "static/media/checkbox-checked.4bc0b01cb83ef2ed65b3ba806ccb1351.svg";
export { ForwardRef as ReactComponent };